/* eslint-disable react-hooks/exhaustive-deps */
import { useApi } from '@backstage/core-plugin-api';
import {
  NotificationApi,
  notificationApiRef,
} from '../../../apis/notificationApi';
import { toolsProvisioningApiRef } from '../../../apis/toolsProvisioningApi';
import { useEffect, useState } from 'react';
import { IConfigOptions } from '../interfaces';

export const useGetConfigOptions = (shouldcall: boolean) => {
  const notificationApi: NotificationApi = useApi(notificationApiRef);
  const toolsprovisioningApi = useApi(toolsProvisioningApiRef);

  const [cofigOptions, setConfigOptions] = useState<IConfigOptions | null>(
    null,
  );
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const fetchMyAPI = async () => {
    if (toolsprovisioningApi) {
      setIsLoading(true);
      try {
        const response: any = await toolsprovisioningApi.getConfigOptions();
        if (response) {
          setIsLoading(false);
          setConfigOptions(response.options);
        }
      } catch (error) {
        notificationApi.sendNotification({
          message: `Error occurred - ${error}`,
          disapperAfterMs: 2500,
          severity: 'error',
        });
      }
    }
  };

  useEffect(() => {
    if (shouldcall) fetchMyAPI();
  }, [shouldcall]);

  return [cofigOptions, isLoading] as const;
};
